import {XOptionGroup} from "./UtilsCommon";

// ciselnik diagnozy mame (zatial) tuto natvrdo, lebo obsahuje grouping
// (ak bude treba, tak treba vytvorit samostatnu dvojtabulku)
// pozor kody (atribut code) musia byt unique (zapisuju sa do DB)
// ciselnik pouzivame na frontend-e aj na backend-e (pri tlaci)
export const diagnozyOptions: XOptionGroup[] = [
    {
        label: 's telesným postihnutím',
        items: [
            { label: 'Detská mozgová obrna', code: 'dmo' },
            { label: 'Parkinsonova choroba', code: 'parkinson' },
            { label: 'Skleróza multiplex, muskulárna dystrofia', code: 'sm-md' },
            { label: 'Neurodegeneratívne ochorenia', code: 'neurodegenerativne-ochorenia' },
            { label: 'Iné telesné a neurologické poruchy', code: 'ine-telesne-poruchy' }
        ]
    },
    {
        label: 's duševným postihnutím',
        items: [
            { label: 'Alzheimer a demencie rôzneho typu etyológie', code: 'alzheimer' },
            { label: 'Organický psychosyndróm', code: 'psychosyndrom' },
            { label: 'Pervazívna vývinová porucha', code: 'pervazivna-porucha' },
            { label: 'Schizofrénia a schizotypové poruchy', code: 'schizofrenia' },
            { label: 'Afektívne poruchy', code: 'afektivne-poruchy' },
            { label: 'Iné nešpecifikované duševné poruchy', code: 'ine-dusevne-poruchy' }
        ]
    },
    {
        label: 's mentálnym postihnutím',
        items: [
            { label: 'mentálne postihnutie', code: 'mentalne-postihnutie' }
        ]
    },
    {
        label: 's chronickým ochorením alebo postihnutím',
        items: [
            { label: 'AIDS', code: 'aids' },
            { label: 'Diabetes mellitus', code: 'diabetes' },
            { label: 'Iné chronické ochorenie (napr. kardiovaskulárne ochorenia, astma alebo chronické obštrukčné pľúcne ochorenia)', code: 'ine-chronicke-ochorenie' },
            { label: 'Kombinované', code: 'chronicke-ochorenie-kombinovane' }
        ]
    },
    {
        label: 'so zmyslovým postihnutím',
        items: [
            { label: 'Zrakové', code: 'zrakove-postihnutie' },
            { label: 'Sluchové', code: 'sluchove-postihnutie' },
            { label: 'Kombinované', code: 'zmyslove-postihnutie-kombinovane' }
        ]
    }
];
